import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'TPAPopup',
	loadComponent: () => import('./TPAPopup.js' /* webpackChunkName: "TPAPopup" */),
}

export default entry
